export function Bases26VeContent() {
  return (
    <>
      <h1>Platanus Hack 26: Caracas ft. Yummy - Bases</h1>

      <p>
        El siguiente documento establece las bases de tu participación en
        Platanus Hack: Caracas (el "Evento"), una hackatón organizada por
        Platanus Ventures SpA ("Platanus") en Caracas, Venezuela. Este instrumento
        constituye un contrato entre Platanus y el participante, que debes
        observar como condición de acceso al Evento.
      </p>

      <h2>Aceptación de estas bases</h2>

      <p>
        Postular o participar del Evento indica que aceptas todas las bases
        descritas a continuación. Por lo tanto, léelas.
      </p>

      <p>
        Si no estás de acuerdo con la totalidad de las bases a continuación, no
        seas parte de Platanus Hack. Además, si una estipulación necesita
        aclaración de nuestra parte, haznos saber a través del correo
        electrónico <a href="mailto:hack@platan.us">hack@platan.us</a>.
      </p>

      <p>
        Aceptas la equivalencia de tu firma electrónica para suscribir este
        documento.
      </p>

      <h2>Cambios de estas bases</h2>

      <p>
        Nos reservamos el derecho de alterar estas bases, unilateralmente, en
        cualquier momento, sin aviso particular alguno que fuere adicional a su
        publicación en el sitio{' '}
        <a href="https://hack.platan.us/26-ve/bases">
          https://hack.platan.us/26-ve/bases
        </a>
        .
      </p>

      <p>
        Es tu completa responsabilidad revisar aquel sitio para consultar la
        última versión vigente de las bases. En el sitio se indicará la fecha de
        la modificación más reciente de las bases.
      </p>

      <p>
        Participar en el Evento o continuar tu participación significa aceptar
        cualquier modificación publicada sobre las bases.
      </p>

      <p>
        Los cambios a las bases entran en vigencia apenas fueren publicados, o
        en los términos que el propio cambio exprese.
      </p>

      <h2>Política de privacidad</h2>

      <p>
        Los datos personales que has suministrado para tu inscripción y
        participación en el Evento, y para tu uso del sitio web del Evento,
        serán almacenados y tratados para:
      </p>

      <ol>
        <li>Aquello conducente a la organización y realización del Evento.</li>
        <li>
          Su comunicación a los sponsors del Evento que Platanus seleccione,
          para que estos últimos los usen con fines de <em>networking</em> y
          reclutamiento de talento.
        </li>
        <li>
          Que continuemos comunicándonos contigo para futuras iniciativas de
          Platanus.
        </li>
        <li>
          Mejorar el sitio web utilizado para el Evento y otros sitios web de
          Platanus.
        </li>
      </ol>

      <p>Tú aceptas todas estas finalidades.</p>

      <p>
        Conservas todos los derechos que la legislación de protección de datos
        personales aplicable te ofrece, entre ellos los de acceso,
        rectificación, cancelación y oposición, que podrás ejercer por
        comunicación al correo electrónico{' '}
        <a href="mailto:hack@platan.us">hack@platan.us</a>.
      </p>

      <p>
        Asimismo, podrás solicitar en cualquier momento que tus datos no sean
        compartidos con los sponsors del Evento, así como darte de baja de las
        comunicaciones sobre futuras iniciativas de Platanus, sin que ello
        afecte tu participación en el Evento.
      </p>

      <h2>Código de conducta</h2>

      <p>
        Incorporamos por referencia el código de conducta de la organización
        CommunityOS, mutatis mutandis para Platanus, publicado en el siguiente
        enlace:{' '}
        <a href="https://github.com/CommunityOS/code_of_conduct/blob/2947d67060b84c9c3e5aad22da1f3367dcc3e1ad/README.md">
          https://github.com/CommunityOS/code_of_conduct
        </a>
      </p>

      <p>
        Tú aceptas que Platanus sea la autoridad final e indisputable de la
        aplicación del código de conducta, pudiendo excluirte o de cualquier
        otra forma disminuir tu participación en el Evento por su infracción.
        Iguales medidas puede aplicar Platanus por tu infracción de cualquiera
        otra de las disposiciones de estas bases.
      </p>

      <p>
        Liberas a Platanus de tener que expresarte una fundamentación detallada
        por las medidas que se te pudieran aplicar por infringir el código de
        conducta, bastándote incluso una comunicación verbal y simple.
      </p>

      <p>
        Entiendes que una condición esencial por la que Platanus te ha admitido
        al Evento ha sido tu observancia del código de conducta.
      </p>

      <h2>Solución de controversias</h2>

      <p>
        Cualquier dificultad o controversia que se produzca en relación con el
        presente contrato de bases, incluido cualquier asunto vinculado a su
        aplicación, interpretación, duración, validez, ejecución o terminación,
        será sometido al siguiente procedimiento:
      </p>

      <ol>
        <li>
          La cuestión será planteada a Platanus, verbalmente al dependiente de
          Platanus presente en el Evento, o por escrito a{' '}
          <a href="mailto:hack@platan.us">hack@platan.us</a>, para su
          resolución.
        </li>
        <li>
          En disconformidad del criterio que dictamine Platanus, las partes
          podrán, de común acuerdo, someter el asunto a arbitraje voluntario
          ante Patricio Andrés Sainz Reyes, en calidad de amigable componedor.
          Las partes declaran saber que el árbitro asesoró en la redacción de
          estas bases y, conservando aquel su independencia de Platanus, lo
          dispensan de la implicancia derivada de esos hechos. A falta de
          acuerdo de arbitraje, serán competentes los tribunales ordinarios con
          asiento en Caracas, sin perjuicio de los fueros que resulten
          irrenunciables conforme a la legislación aplicable.
        </li>
      </ol>

      <p>
        También aceptas someter al procedimiento recién descrito las
        controversias que tengas con otros participantes del Evento, con ocasión
        de actividades en el mismo.
      </p>

      <h2>Ley aplicable</h2>

      <p>
        Estas bases se rigen por las leyes de la República Bolivariana de Venezuela respecto
        de los participantes con residencia en Venezuela; en lo demás, por las
        leyes de la República de Chile. En todo caso, prevalecerán las normas
        imperativas y de orden público que resulten aplicables, incluidas las de
        protección al consumidor y de protección de datos personales.
      </p>

      <h2>Otras reglas</h2>

      <ol>
        <li>
          <strong>Forma de participación</strong>: solamente podrán participar
          aquellos equipos que sean seleccionados a través del proceso de
          postulación disponible en{' '}
          <a href="https://hack.platan.us/26-ve">
            https://hack.platan.us/26-ve
          </a>
          , o que fueren invitados por Platanus.
        </li>
        <li>
          <strong>Selección de postulantes</strong>: Platanus es la única
          autoridad de selección de postulantes y lo hará a su entera
          discreción, por los motivos que estime mejores para el éxito del
          Evento.
        </li>
        <li>
          <strong>Costo de participación</strong>: La participación en el Evento
          es gratuita.
        </li>
        <li>
          <strong>Lugar de desarrollo</strong>: el Evento se llevará a cabo en
          Caracas, Venezuela, en un lugar que se comunicará antes del Evento. Solo podrán asistir los
          equipos seleccionados y los invitados de Platanus. Platanus se reserva
          el derecho de variar este lugar de desarrollo.
        </li>
        <li>
          <strong>Procedencia de los equipos</strong>: Se permite la
          participación de equipos de cualquier ciudad o país, siempre y cuando
          todo el equipo asista al Evento de manera presencial. No se cubren
          gastos de alojamiento, pasajes y estadía en general.
        </li>
        <li>
          <strong>Materiales</strong>: es tu responsabilidad como participante
          traer tus propios equipos tecnológicos y demás materiales para tu
          subsistencia, comodidad y participación en el Evento.
        </li>
        <li>
          <strong>Idioma de las actividades</strong>: El idioma principal de las
          actividades será en español.
        </li>
        <li>
          <strong>Participación remota o híbrida</strong>: No se permite la
          participación remota o híbrida. El evento es completamente presencial.
          Todos los integrantes del equipo deben estar presentes en el evento.
        </li>
        <li>
          <strong>
            Participación en múltiples proyectos, y proyectos por equipo
          </strong>
          : No se permite que los integrantes participen en múltiples proyectos
          o equipos. Cada equipo no puede postular más de un proyecto.
        </li>
        <li>
          <strong>Propiedad intelectual</strong>: La propiedad intelectual de
          todo lo producido por el equipo durante el evento pertenece plena y
          solamente al equipo.
        </li>
        <li>
          <strong>Construcción de prototipos</strong>: el Evento culmina con una
          demostración de prototipos. Solo los equipos con una demostración
          funcional tendrán la posibilidad de presentar en la final del día
          domingo 25 de octubre de 2026.
        </li>
        <li>
          <strong>Conocimientos requeridos</strong>: Es recomendable que el
          equipo esté familiarizado con la tecnología que planean utilizar y el
          área o problema que abordarán.
        </li>
        <li>
          <strong>Mentorías disponibles</strong>: Habrá acceso a mentores en
          startups, ciencia, diseño, datos y programación/ingeniería. Los
          equipos podrán solicitar asistencia de manera regular durante el
          Evento.
        </li>
        <li>
          <strong>Jurado de la hackatón</strong>: El jurado estará compuesto por
          representantes de Platanus y otros expertos en emprendimiento,
          innovación y desarrollo tecnológico. El jurado es la única autoridad
          que puede determinar a los ganadores del Evento y contra su
          determinación no hay recurso alguno.
        </li>
        <li>
          <strong>Criterios de evaluación</strong>: Los proyectos serán
          evaluados en base a innovación, viabilidad, escalabilidad,
          presentación y demostración, y el impacto en las categorías
          priorizadas.
        </li>
        <li>
          <strong>Final del Evento</strong>: Todos los equipos con un prototipo
          funcional tendrán la posibilidad de presentar su proyecto en alguna de
          las instancias finales del domingo 25 de octubre de 2026.
        </li>
        <li>
          <strong>Anuncio del equipo ganador</strong>: El equipo ganador se
          anunciará el domingo 25 de octubre de 2026 durante la hackatón.
        </li>
        <li>
          <strong>Premios</strong>: Se entregarán premios en dinero y/o créditos
          de servicios proporcionados por los sponsors del Evento a los equipos
          ganadores. La composición, monto y condiciones específicas de los
          premios serán comunicados oportunamente por Platanus, sin que
          variaciones respecto de comunicaciones previas generen responsabilidad
          alguna para Platanus.
        </li>
        <li>
          <strong>Responsabilidad por los premios</strong>: la responsabilidad
          de Platanus, como organizador del Evento, se limita nada más a
          conducir a los sponsors del Evento la instrucción de entregar los
          premios concedidos a los ganadores. Platanus no intermedia en la
          entrega de los premios y no garantiza de modo alguno la conducta de
          los sponsors, como lo sería la entrega y su oportunidad. Esta
          limitación de responsabilidad no aplica respecto de los premios que
          sean de cargo de Platanus.
        </li>
        <li>
          <strong>Adjudicación de premios al equipo</strong>: los premios de la
          competencia hackatón se adjudicarán a cada participante de los equipos
          ganadores.
        </li>
        <li>
          <strong>Derechos de imagen y nombre, colaboración</strong>: es
          condición esencial de tu participación en el Evento tu autorización,
          sin remuneración, que en este acto otorgas, a usar tu imagen y nombre
          para la promoción del Evento (antes, durante y después de aquel), de
          sus futuras ediciones y de las actividades habituales de Platanus, por
          un plazo de 10 años contados desde la realización del Evento. El
          Evento podrá ser videograbado y tales grabaciones podrán formar parte
          del material publicitario de Platanus. Además, te comprometes a
          prestar tu colaboración para entrevistas y otras actividades de prensa
          y difusión convocadas por Platanus, especialmente en el caso de que
          fueres ganador.
        </li>
        <li>
          <strong>Daños</strong>: exoneras de toda responsabilidad a Platanus
          por los daños que te pudieran ocurrir con ocasión del Evento, salvo
          dolo o culpa grave de Platanus, o daños a la integridad física que le
          sean imputables. Tú te comportarás con esmerada diligencia para no
          accidentarte ni desarrollar enfermedades en el lugar del Evento. Tu
          participación es bajo tu propio riesgo.
        </li>
        <li>
          <strong>Indemnizaciones</strong>: te comprometes a dejar indemne a
          Platanus, sin limitación, por cualquier hecho tuyo con ocasión de tu
          participación en el Evento que le irrogue perjuicios, o que
          irrogándole perjuicios a terceros, estos terceros se dirijan contra
          Platanus. Tu deber de indemnización se extiende además a las costas
          judiciales y personales.
        </li>
        <li>
          <strong>Instrucciones de la organización</strong>: te comprometes a
          observar las instrucciones que Platanus y sus colaboradores te
          impartan para la correcta ejecución del Evento, así como su aseo y
          ornato.
        </li>
      </ol>
    </>
  );
}
